// extracted by mini-css-extract-plugin
export default {"cls1":"LWbwT6rtHj3onrfYpwdA","cls2":"nd77CtqhLMNlsMUzuO3q LWbwT6rtHj3onrfYpwdA"};